import React from "react";
import { useNavigate } from "react-router-dom";
import { ActivePackagesDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { expeditionRoutes } from "../../../../../../router/routesConstants";
import CustomButton from "../../../../../../components/CustomButton";
import SvgIcon from "../../../../../../helpers/SvgIcon";

function ClientAwbHistoryActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: ActivePackagesDataInterface;
}) {
  const navigate = useNavigate();

  const handleGetPackages = () => {
    if (itemId) {
      navigate(
        `${expeditionRoutes.activePackages}?idExpeditie=${itemId}&client=${crudData.client}`,
      );
    }
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Colete active"
        onClick={handleGetPackages}>
        <SvgIcon type="PACKAGES" fill="white" />
      </CustomButton>
    </div>
  );
}

export default ClientAwbHistoryActionButtons;
